<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.agentId"
        placeholder="请选择"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in daiList"
          :key="item.id"
          :label="item.agentName"
          :value="item.id"
        />
      </el-select>
      <el-input
        v-model="listQuery.userId"
        placeholder="会员ID"
        style="width: 300px"
        class="filter-item"
        clearable
      />

      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column align="center" prop="name" label="姓名" width="95"></el-table-column>
      <el-table-column align="center" prop="nickname" label="昵称" width="95"></el-table-column>
      <el-table-column align="center" prop="mobile" label="手机号码" width="120"></el-table-column>
      <el-table-column
        align="center"
        prop="inviteCode"
        label="邀请码"
        width="120"
      ></el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="90">
        <template slot-scope="scope">
          <span>{{ getValue(IS_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="certStatus" label="实名认证状态" width="140">
        <template slot-scope="scope">
          <span>{{ getValue(MEMBER_CER_STATUS, scope.row.certStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="certType" label="证件类型" width="120">
        <template slot-scope="scope">
          <span>{{ getValue(MEMBER_EXAMINE_TYPE, scope.row.certType) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="certNo" label="证件号码" width="180"></el-table-column>
      <el-table-column
        align="center"
        prop="isBindInvitationCode"
        label="是否绑定邀请码"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{ getValue(YES_NO_LIST, scope.row.isBindInvitationCode ? 1 : 0) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="contractStatus" label="合同状态" width="140">
        <template slot-scope="scope">
          <span>{{ getValue(CONTRACT_STATUS, scope.row.contractStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="agentId" label="代理商ID" width="120"></el-table-column>
      <el-table-column
        align="center"
        prop="agentName"
        label="代理商名称"
        width="120"
      ></el-table-column>

      <el-table-column
        align="center"
        prop="regionAddress"
        label="地区地址"
        width="200"
      ></el-table-column>

      <el-table-column align="center" prop="ctdate" label="创建时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleAdd(scope.row)" class="comm_but_warp"
            >新增</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :visible.sync="isBo" :append-to-body="true">
      <div class="dialog-view" v-if="curRow">
        <span style="font-size:30px;" class="dia-pos">添加代理合伙人</span>
        <div class="dialog-content">
          <div class="dialog-left">
            会员ID:
          </div>
          <div class="dialog-right">
            {{ curRow.id }}
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            合伙人ID:
          </div>
          <div class="dialog-right">
            <el-input style="width: 200px" v-model="partnerId" placeholder="请输入" />
          </div>
          <el-select
            v-model="teamLogo"
            placeholder="团队标识"
            style="width: 120px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in TEAM_LOGO_ENUM"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            分红比例:
          </div>
          <div class="dialog-right">
            <el-input
              style="width: 200px"
              v-model="ration"
              placeholder="请输入"
              type="number"
              :min="0"
              :max="1"
              @input="handleRationInput"
            />
          </div>
        </div>
      </div>
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onBoHui">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getAgentPartnerAreaList, addAgentPartnerArea } from "@/api/agent";
import { getAgentConfigList } from "@/api/regionAgent";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  AHENT_LIST,
  IS_STATUS,
  MEMBER_CER_STATUS,
  MEMBER_EXAMINE_TYPE,
  CONTRACT_STATUS,
  YES_NO_LIST,
  TEAM_LOGO_ENUM
} from "@/utils/enumUtile";
import RegionPicker from "@/views/components/regionPicker.vue";

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      isBo: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        agentId: null,
        userId: null
      },
      curRow: {},
      ration: null,
      partnerId: null,
      teamLogo: null,
      daiList: []
    };
  },
  created() {
    this.getList();
    this.getDai();
  },
  methods: {
    getValue,
    handleAdd(row) {
      this.getDai();
      this.curRow = row;
      this.isBo = true;
    },
    onBoHui() {
      addAgentPartnerArea({
        userId: this.curRow.id,
        partnerId: this.partnerId,
        ration: this.ration,
        teamLogo: this.teamLogo
      }).then(res => {
        if (res.bizcode === 100) {
          this.$message.success("新增成功");
          this.getList();
          this.onClose();
        }
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      getAgentPartnerAreaList(this.listQuery).then(res => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        this.listLoading = false;
      });
    },
    onClose() {
      this.remark = "";
      this.curRow = null;
      this.isBo = false;
    },
    handleRationInput(val) {
      if (val === "" || val === null || val === undefined) {
        this.ration = "";
        return;
      }
      let valStr = String(val).replace(/[^\d.]/g, "");
      const parts = valStr.split(".");
      if (parts.length > 2) {
        valStr = parts[0] + "." + parts.slice(1).join("");
      }
      const num = parseFloat(valStr);
      if (!isNaN(num)) {
        if (num > 1) {
          valStr = "1";
        } else if (num < 0) {
          valStr = "0";
        }
      }
      this.ration = valStr;
      this.$nextTick(() => {
        this.ration = valStr;
      });
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    getDai() {
      this.listLoading = true;
      getAgentConfigList({ page: 1, pageize: 1000 }).then(res => {
        this.daiList = res.data.entitys;
        this.listLoading = false;
      });
    }
  },
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    AHENT_LIST() {
      return AHENT_LIST;
    },
    IS_STATUS() {
      return IS_STATUS;
    },
    MEMBER_CER_STATUS() {
      return MEMBER_CER_STATUS;
    },
    MEMBER_EXAMINE_TYPE() {
      return MEMBER_EXAMINE_TYPE;
    },
    CONTRACT_STATUS() {
      return CONTRACT_STATUS;
    },
    YES_NO_LIST() {
      return YES_NO_LIST;
    },
    TEAM_LOGO_ENUM() {
      return TEAM_LOGO_ENUM;
    }
  },
  components: { RegionPicker }
};
</script>

<style lang="scss" scoped>
.dialog-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 30px;
  position: relative;

  .dialog-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .dialog-left {
      width: 200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }

    .dialog-right {
      flex: 1;
      margin-left: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .dia-pos {
    position: absolute;
    top: -70px;
  }
}

.image-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .download-btn {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(64, 158, 255, 0.9);
    border: none;
    color: #fff;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 16px;
    opacity: 0;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      background: rgba(64, 158, 255, 1);
      transform: translateX(-50%) scale(1.05);
    }
  }

  &:hover .download-btn {
    opacity: 1;
  }
}

.upload-list {
  ::v-deep .upload_list_warp {
    .el-upload {
      width: 80px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ::v-deep .el-upload__tip {
    display: none;
  }
}
</style>
